module.exports = __webpack_public_path__ + "img/australianrules.380de59d.svg";